import type { PortfolioTab } from './components/PopulatedState';

type Metadata = {
  title: string;
  description: string;
};

const METADATA_MAP: Record<PortfolioTab, Metadata> = {
  holdings: {
    title: 'Demo Portfolio Holdings',
    description:
      'Explore the stocks in our demo portfolio. See holdings breakdown, performance, weightings, and valuations - and learn how to structure your own portfolio.',
  },
  narratives: {
    title: 'Demo Portfolio Narratives',
    description:
      'See how company stories shape portfolio decisions. Explore stock narratives and updates in our demo portfolio - and how you can track yours too.',
  },
  returns: {
    title: 'Demo Portfolio Returns Report',
    description:
      'Review detailed return metrics including CAGR, realised and unrealised gains, and total performance - powered by real transactions in our demo portfolio.',
  },
  updates: {
    title: 'Demo Portfolio Updates',
    description:
      'Stay informed with the latest updates and news related to the stocks in our demo portfolio.',
  },
  dividend: {
    title: 'Demo Portfolio Dividend Tracker',
    description:
      'Track dividend income, yield, payout forecasts and past payments from stocks in our demo portfolio. See how we help you build income-generating portfolios.',
  },
  analysis: {
    title: 'Demo Portfolio Analysis & Insights',
    description:
      "Analyse our demo portfolio's valuation, future growth, risk exposure and diversification. Discover the tools that help optimise real portfolios like yours.",
  },
};

export const getMetadata = (tab?: PortfolioTab): Metadata => {
  if (typeof tab !== 'undefined') return METADATA_MAP[tab];
  return {
    title: 'Explore Our Demo Portfolio',
    description:
      'See Simply Wall St in action with a live demo portfolio. Explore holdings, returns, dividends, valuations, and narratives - no signup required.',
  };
};
